import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Spinner } from "../Spinner/Spinner";

export function Button({ buttonTxt, buttonStyle, clickHandler }) {
  const [isLoading, setIsLoading] = useState(false);
  let buttonStyles = "basicBtnStyle";

  async function localClickHandler() {
    setIsLoading(true);
    clickHandler().then(()=>{
        setIsLoading(false);
    })
  }

  if (buttonStyle) {
    buttonStyles = buttonStyle;
  }

  return (
    <>
      <button className={buttonStyles} onClick={localClickHandler}>
        {isLoading ? <Spinner /> : buttonTxt}
      </button>
    </>
  );
}

Button.propTypes = {
  buttonTxt: PropTypes.string,
  clickHandler: PropTypes.func,
};
